import React from 'react';

import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../../features/track';
import { addAccountUrl } from '../../../Shared/addAccountUrl';
import { urlBuilder } from '../../../Shared/urlBuilder';

export const UserPerformanceLink: React.FC = () => (
  <SambaAutoLink
    aria-label="See details of investing performance"
    data-testid="performanceDetailLink"
    to={urlBuilder.appPerformance.absolute()}
    onClick={() => trackClick({ name: 'SeePerformanceDetail', location: 'Summary', module: 'InvestmentPerformance' })}
  >
    See details
  </SambaAutoLink>
);

export const BoostApyLink: React.FC = () => (
  <SambaAutoLink
    variant="textPrimary"
    to={urlBuilder.appRewards.absolute()}
    css={{ ml: 'space.100', textStyle: 'text50' }}
  >
    Boost APY
  </SambaAutoLink>
);

export const OpenCashAccountLink: React.FC = () => (
  <SambaAutoLink
    to={`${addAccountUrl({ product_category: 'cash' })}`}
    aria-label="Sign up for a Cash account to earn interest"
    onClick={() => {
      trackClick({
        name: 'SignUpForCash',
        module: 'InvestmentPerformance',
        location: 'Summary',
      });
    }}
  >
    Open account
  </SambaAutoLink>
);

export const TaxLossHarvestingSetupLink: React.FC = () => (
  <SambaAutoLink
    to={urlBuilder.appTlhSetupSuitabilityIntroduction.absolute()}
    aria-label="Turn on tax loss harvesting"
    data-testid="tlhLink"
    onClick={() => trackClick({ name: 'EnableTlh', module: 'InvestmentPerformance', location: 'Summary' })}
  >
    Turn on
  </SambaAutoLink>
);
